import PubSub from "underpub-js";
var Cookies = require("js-cookie");
import ConsentedCookie from '../../../../scripts/classes/ConsentedCookie';

var AlertComponent = function (options) {

  this.options = {
    $el: false
  };

  $.extend(true, this.options, options);

};

AlertComponent.prototype.init = function () {

  var self = this;

  // setting our static height so when we animate,
  // it transitions nicely
  var height = this.options.$el.height();
  this.options.$el.height(height);

  var cookieName = this.options.$el.data('cookie-name');
  var cookieValue = this.options.$el.data('cookie-value');

  this.options.$el.find(".text-alert-close").on("click", function () {
    self.options.$el.height(0);
    if (cookieName && cookieValue) {
      ConsentedCookie.set(cookieName, cookieValue, 'functional', { expires: 30 });
    }
  });

  PubSub.subscribe('resized', function () {
    self.options.$el.height('auto');
    var height = self.options.$el.height();
    self.options.$el.height(height);
  });

};

export default AlertComponent;
